// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export const styles = css`
  text-align: center;
  ${(props) =>
    props.isAddedToBagRedesign &&
    `
          padding-bottom:9px;
          border: 1px solid ${props.theme.colorPalette.gray[600]};
          border-radius: 6px;
        `}

  margin-bottom: 32px;
  .bossText {
    margin: 10px 0 0 0;
    width: 100%;
  }
  ${(props) =>
    props.isAddedToBagRedesign &&
    `
    .spanNoRush b{
      font-weight: ${props.theme.fonts.fontWeight.extrabold};
    }
    `}
`;

export default styles;
